import c from './constants';

class DbInfo extends Array {

	constructor(arr) {
		super();
		arr.forEach(item => this.push(item));
	}

	get(id) {
		for (let i = 0; i < this.length; i++) {
			if (this[i].id == id) {
				return this[i].title;
			}
		}
	}

	getArray(id) {
		const res = [];
		for (let i = 0; i < this.length; i++) {
			for (let j = 0; j < id.length; j++) {
				if (this[i].id == id[j]) {
					res.push(this[i].title);
				}
			}
		}
		return res;
	}


	getItem(id) {
		for (let i = 0; i < this.length; i++) {
			if (this[i].id == id) {
				return this[i];
			}
		}
	}

	asArray() {
		let arr = [];
		for (let i = 0; i < this.length; i++) {
			const keys = Object.keys(this[i]);
			const o = {};
			keys.forEach((key) => {
				o[key] = this[i][key];
			});
			arr.push(o);
		}
		return arr;
	}

	asObject() {
		let arr = {};
		for (let i = 0; i < this.length; i++) {
			arr[this[i].id] = this[i].title;
		}
		return arr;
	}
}

const DbInfos = {};

DbInfos.YesNo = new DbInfo([
    {id: 1, title: 'Ano'},
    {id: 0, title: 'Ne'}
]);

DbInfos.TrainingDuration = new DbInfo([
	{id: 1, title: '1 rok'},
	{id: 2, title: '2 roky'},
  {id: 3, title: '3 roky'},
]);

DbInfos.ETrainingStatus = new DbInfo([
	{id: 1, title: 'probíhá'},
  {id: 3, title: 'čeká na PZ'},
  {id: 4, title: 'nedokončeno'},
	{id: 2, title: 'uzavřeno'},
]);

DbInfos.Rating = new DbInfo([
    {id: 1, title: 'A'},
    {id: 2, title: 'B'},
    {id: 3, title: 'C'},
	{id: 4, title: '0'},
	{id: 5, title: 'X'},
]);

DbInfos.TrainingType = (store) => {
	return new DbInfo(store.getState().dbinfo.trainingType);
};

DbInfos.DocumentType = new DbInfo([
	{id: 1, title: 'soubory ke stažení / videa'},
	{id: 2, title: 'youtube video'},
]);

DbInfos.OrderStatus = new DbInfo([
    {id: 1, title: 'nová'},
	{id: 3, title: 'vystavená'},
    {id: 2, title: 'zaplacená'},
]);

DbInfos.OrderPersonal = new DbInfo([
	{id: 1, title: 'soukromé'},
	{id: 2, title: 'firemní'},
]);

DbInfos.InvoiceClientType = new DbInfo([
	{id: 1, title: 'firma'},
	{id: 2, title: 'řidič'},
]);


DbInfos.LogAction = new DbInfo([
	{id: 6, title: 'neúspěšné přihlášení'},
	{id: 1, title: 'přihlášení'},
  {id: 2, title: 'stažení dokumentu'},
  {id: 3, title: 'přehrátí videa'},
  {id: 4, title: 'spuštění cvičného testu'},
  {id: 5, title: 'spuštění závěrečného testu'},
  {id: 7, title: 'spuštění cvičného testu se zápočtem'},
  {id: 8, title: 'dokončení cvičného testu se zápočtem'},

]);

DbInfos.TemplateType = new DbInfo([
    {id: 1, title: 'Záznam o školení'},
    {id: 2, title: 'Protokol k záznamu o školení'},
    {id: 3, title: 'Záznam o praktickém zácviku'},
	{id: 8, title: 'Záznam o praktickém zácviku (e-školení)'},
	{id: 9, title: 'Protokol k záznamu o e-školení'},
    {id: 4, title: 'Evidenční list obsluhy manipulačních vozíků'},
	{id: 5, title: 'Protokol o technické kontrole motorového vozíku'},
	{id: 6, title: 'Příloha k protokolu o technické kontrole motorového vozíku'},
	{id: 7, title: 'Záznam o elektronickém školení'},
]);

DbInfos.Month = new DbInfo([
    {id: 1, title: 'Leden'},
    {id: 2, title: 'Únor'},
    {id: 3, title: 'Březen'},
    {id: 4, title: 'Duben'},
    {id: 5, title: 'Květen'},
    {id: 6, title: 'Červen'},
    {id: 7, title: 'Červenec'},
    {id: 8, title: 'Srpen'},
    {id: 9, title: 'Září'},
    {id: 10, title: 'Říjen'},
    {id: 11, title: 'Listopad'},
    {id: 12, title: 'Prosinec'}
]);

DbInfos.MonthShort = new DbInfo([
    {id: 1, title: 'Led'},
    {id: 2, title: 'Úno'},
    {id: 3, title: 'Bře'},
    {id: 4, title: 'Dub'},
    {id: 5, title: 'Kvě'},
    {id: 6, title: 'Črn'},
    {id: 7, title: 'Črc'},
    {id: 8, title: 'Srp'},
    {id: 9, title: 'Zář'},
    {id: 10, title: 'Říj'},
    {id: 11, title: 'Lis'},
    {id: 12, title: 'Pro'}
]);

DbInfos.DayShort = new DbInfo([
    {id: 1, title: 'Po'},
    {id: 2, title: 'Út'},
    {id: 3, title: 'St'},
    {id: 4, title: 'Čt'},
    {id: 5, title: 'Pá'},
    {id: 6, title: 'So'},
    {id: 0, title: 'Ne'}
]);

DbInfos.InvoiceStatus = new DbInfo([
  {id: c.INVOICE_STATUS.NEW, title: 'vystaveno'},
  {id: c.INVOICE_STATUS.PAYED, title: 'zaplaceno'}
]);

export default DbInfos;


// WEBPACK FOOTER //
// ./src/dbinfo.js